/** Main app route for Collections (not under Ledger). */
export const COLLECTIONS_PAGE_PATH = '/app/collections';

/** @deprecated Use COLLECTIONS_PAGE_PATH — kept for imports that still use the old name. */
export const INTERAC_PAYMENT_PAGE_PATH = COLLECTIONS_PAGE_PATH;

export const COLLECTIONS_PAGE_LABEL = 'Collections';

export const INTERAC_PAYMENT_PAGE_LABEL = COLLECTIONS_PAGE_LABEL;

/** Default ledger book for portal Interac collections. */
export const COLLECTIONS_DEFAULT_ACCOUNT_ID = 'AC01';
